var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('with-icon',{attrs:{"icon":_vm.icon}},[_c('labeled-content',{attrs:{"label":_vm.label}},[_c('local-date-text',{attrs:{"value":_vm.value,"allow-close-dates":_vm.allowCloseDates}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }